import ClientBase from "@citrine/client";

import type { GEMTableConfig, TableConfigIdentifier } from "./gem-table-config";

export class GEMTableConfigClient extends ClientBase<
  GEMTableConfig,
  TableConfigIdentifier
> {
  clone!: never;
  useClone!: never;
  create!: never;
  useCreate!: never;
  delete!: never;
  useDelete!: never;
  find!: never;
  useFind!: never;
  useMap!: never;
  update!: never;
  useUpdate!: never;

  protected constructor(projectId: string) {
    super({
      endpoint: `/api/v1/projects/${projectId}/ara-definitions`,
    });
  }

  static getInstance(projectId: string) {
    return new this(projectId);
  }

  getId(model: GEMTableConfig): TableConfigIdentifier {
    return {
      id: model.definition.id,
      version: model.version.id,
    };
  }

  getUri(identifier?: TableConfigIdentifier): string {
    return `${this.endpoint}/${identifier?.id}/versions/${identifier?.version}`;
  }
}
